// extracted by mini-css-extract-plugin
export default {"filterPanel":"rsCBBT"};